export function getDateUTC(dateEpoch: number): number {
  const utcDate = new Date(dateEpoch);
  return new Date(
    Date.UTC(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate()),
  ).getTime();
}
